import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, takeUntil, tap } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';
import {
	bulkDelete,
	bulkDeleteSuccess,
	DatablockSelector,
	deleteDatablock,
	deleteDatablockSuccess,
	persistDatablocks,
	persistenceActionsAccepted,
	repersistDatablocks,
	unpersistDatablocks,
} from '../../store';

export enum DatablockAction {
	Persist = 'persist',
	Repersist = 'repersist',
	Depersist = 'depersist',
	Delete = 'delete',
}

export interface IDatablockDeleteModalData {
	datablockId: number | Array<number>;
	element: string;
	action: DatablockAction;
}
@Component({
	selector: 'app-datablock-action-popup',
	templateUrl: './datablock-action-popup.component.html',
	styleUrls: ['./datablock-action-popup.component.scss'],
})
export class DatablockActionPopupComponent<
	T extends IDatablockDeleteModalData
> extends DcBaseComponent {
	public readonly Icons = DcIcons;
	public vo$: Observable<{
		element: string;
		datablockId: number | Array<number>;
		isMultipleElement: boolean;
		action: DatablockAction;
		isActionInProgress: boolean;
	}>;
	public confirmDeletion = false;

	protected readonly DcIcons = DcIcons;
	protected readonly DatablockAction = DatablockAction;
	public constructor(
		private readonly modalService: AppModalService,
		private readonly store: Store,
		private readonly datablockSelector: DatablockSelector,
		private readonly actions$: Actions,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'datablock-action';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.datablockId) &&
				this.modalData.element === '',
			datablockId: this.modalData.datablockId,
			action: this.modalData.action,
			isActionInProgress: this.datablockSelector.getActionInProgress$(),
		});

		this.handleSubscriptions();
	}

	public confirmAction(): void {
		const datablockIds = this.datablockIds();
		switch (this.modalData.action) {
			case DatablockAction.Persist:
				return this.store.dispatch(
					persistDatablocks({
						datablockIds,
					})
				);
			case DatablockAction.Repersist:
				return this.store.dispatch(
					repersistDatablocks({
						datablockIds,
					})
				);
			case DatablockAction.Depersist:
				return this.store.dispatch(
					unpersistDatablocks({
						datablockIds,
					})
				);
			case DatablockAction.Delete:
				if (datablockIds.length === 1) {
					return this.store.dispatch(
						deleteDatablock({
							datablockId: datablockIds[0],
						})
					);
				}
				return this.store.dispatch(
					bulkDelete({
						datablockId: datablockIds,
					})
				);
		}
	}

	private datablockIds(): Array<number> {
		const { datablockId } = this.modalData;
		return Array.isArray(datablockId) ? datablockId : [datablockId];
	}

	private handleSubscriptions(): void {
		this.actions$
			.pipe(
				takeUntil(this.onDestroy$),
				ofType(
					persistenceActionsAccepted,
					deleteDatablockSuccess,
					bulkDeleteSuccess
				),
				tap(() => this.modalService.closeActiveModal())
			)
			.subscribe();
	}
}
